import Api from "../axios";

export const putEditReward = async (data) => {
  return await Api.put("/Game/UpdateReward", data);
};
